import React, { useEffect, useMemo, useState } from "react";
import SideBar from "../components/SideBar";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { useNavigate } from "react-router-dom";
import "../styles/ManageMember.css";
import { parentsConsentService } from "../services/parentsConsentService";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={10} ref={ref} variant="filled" {...props} />;
});

function ManageParentsConsent() {
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("all");
  const [loading, setLoading] = useState(false);
  const [records, setRecords] = useState([]);
  const [snackOpen, setSnackOpen] = useState(false);
  const [snackMessage, setSnackMessage] = useState("");

  const fetchRecords = async () => {
    setLoading(true);
    try {
      const response = await parentsConsentService.list({
        page: 1,
        per_page: 100,
        ...(search ? { search } : {}),
        ...(status !== "all" ? { review_status: status } : {}),
      });
      setRecords(response?.data || []);
    } catch (error) {
      console.error("Failed to load parental consent records", error);
      setRecords([]);
      setSnackMessage("Failed to load parental consent records");
      setSnackOpen(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRecords();
  }, []);

  useEffect(() => {
    fetchRecords();
  }, [status]);

  const statusCounts = useMemo(() => {
    return records.reduce(
      (acc, item) => {
        const key = item.review_status || "pending";
        acc[key] = (acc[key] || 0) + 1;
        return acc;
      },
      { pending: 0, approved: 0, rejected: 0 }
    );
  }, [records]);

  const handleRowClick = (consent) => {
    navigate("/parental-consent-details", { state: { consent } });
  };

  const handleSnackClose = () => setSnackOpen(false);

  return (
    <div className="manage-member-layout">
      <SideBar />
      <div className="main-content">
        <div className="header-bar" style={{ border: 0, boxShadow: "none" }}>
          <div className="header-top">
            <h2 className="header-title">Parental Consent Management</h2>
            {/* <button className="action-btn" onClick={fetchRecords}>
              Refresh
            </button> */}
          </div>

          <div className="filters">
            {/* <div className="input-group">
              <label>Filter by status:</label>
              <select
                value={status}
                onChange={(e) => setStatus(e.target.value)}
                className="filter-select"
              >
                <option value="all">All</option>
                <option value="pending">Pending</option>
                <option value="approved">Approved</option>
                <option value="rejected">Rejected</option>
              </select>
            </div> */}

            <div className="input-group">
              <label>Search:</label>
              <input
                className="search-input"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                placeholder="Child, parent, customer name/email"
              />
            </div>

            <button className="action-btn" onClick={fetchRecords}>
              Apply
            </button>
          </div>
        </div>

        <div className="table-container">
          <table className="member-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Child</th>
                <th>Parent / Guardian</th>
                <th>Customer Email</th>
                <th>Consent Date</th>
                {/* <th>Status</th> */}
              </tr>
            </thead>
            <tbody>
              {records.map((record) => (
                <tr key={record.id} onClick={() => handleRowClick(record)}>
                  <td>{record.id}</td>
                  <td>{record.child_full_name}</td>
                  <td>{record.parent_guardian_name}</td>
                  <td>{record.customers?.email || record.email || "-"}</td>
                  <td>{record.consent_date || "-"}</td>
                  {/* <td>
                    <span className={`status ${record.review_status || "pending"}`}>
                      {record.review_status || "pending"}
                    </span>
                  </td> */}
                </tr>
              ))}
              {loading ? (
                <tr>
                  <td colSpan={5} style={{ padding: 18, textAlign: "center" }}>
                    Loading…
                  </td>
                </tr>
              ) : !loading && records.length === 0 ? (
                <tr>
                  <td colSpan={5} style={{ padding: 18 }}>
                    No parental consent records found.
                  </td>
                </tr>
              ) : null}
            </tbody>
          </table>
        </div>

        <Snackbar open={snackOpen} autoHideDuration={4000} onClose={handleSnackClose}>
          <Alert onClose={handleSnackClose} severity="error">
            {snackMessage}
          </Alert>
        </Snackbar>
      </div>
    </div>
  );
}

export default ManageParentsConsent;
